import Heading from 'components/partials/heading/heading';

interface ProductDetailsProps {
  description?: string;
  customClass?: string;
}

const ProductDetails = ({
  description,
  customClass,
}: ProductDetailsProps): React.JSX.Element => (
  <div className={customClass}>
    <Heading variant="h3" customClass="mb-4 block">
      Product Details
    </Heading>
    <p className="text-gray-700 break-words">{description}</p>
  </div>
);

export default ProductDetails;
